import React from 'react';
import Link from '../Link';
import styled from 'styled-components';
import ChevRight from '../../images/chevron-right.inline.svg';

const ReccentPostWidget = styled.div`
	border-bottom: 1px solid #ced8e1;
	margin-bottom: 35px;
	padding-bottom: 40px;
`;
const RecentPostTitle = styled.h4`
	color: #19214b;
	font-weight: 700;
	font-size: 16px;
	margin: 0 0 15px 0;
`;
const List = styled.div``;
const ListItem = styled.div`
	margin-bottom: 9px;
	:last-child {
		margin-bottom: 0;
	}
	> a {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 16px;
		// color: #99aabb;
		color: #99aabbef;
		font-weight: 500;
		transition: all 0.3s ease-in-out 0s;

		> div {
			border: 1px solid transparent;
			border-radius: 50%;
			width: 27px;
			height: 27px;
			display: flex;
			align-items: center;
			justify-content: center;
			transition: all 0.3s ease-in-out 0s;
			margin-left: 8px;

			> div {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 90%;
				height: 90%;
				border-radius: 50%;

				> svg {
					width: 15px;
					height: 15px;
				}
			}
		}

		:hover {
			color: #e01efe;

			> div {
				background-image: linear-gradient(to right, #ffa1dc, #e01efe);
				> div {
					background-color: #fff;
				}
			}
		}
	}
`;

export default function CategoriesWidget({ categories }) {
	if (!categories) {
		return null;
	}
	return (
		<ReccentPostWidget>
			<RecentPostTitle>Categories</RecentPostTitle>
			<List>
				{categories.edges.map(({ node }) => {
					return (
						<ListItem key={node.id}>
							<Link noPrefetch to={`/${node.slug}/`}>
								<span>{node.name}</span>
								<div>
									<div>
										<ChevRight />
									</div>
								</div>
							</Link>
						</ListItem>
					);
				})}
			</List>
		</ReccentPostWidget>
	);
}
